import { motion, useReducedMotion } from "motion/react";
import {
  YEATIES_CONSENT_MOTION,
  YEATIES_REFUSED_CHANGE_OF_MIND,
  YEATIES_REFUSED_MESSAGE,
  YEATIES_REFUSED_TITLE,
} from "@/features/card/configs/yeatiesConsent.config";
import { getReducedMotionFallback } from "@/features/card/utils/yeatiesConsentMotion.util";

export const YeatiesRefusedPanel = () => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className="mt-6 rounded-lg bg-gray-100 p-4 text-left space-y-1 dark:bg-gray-700"
      data-testid="yeaties-refused-panel"
      {...getReducedMotionFallback(reduceMotion, { from: { opacity: 0 }, to: { opacity: 1 }, transition: YEATIES_CONSENT_MOTION.refusedPanel })}
    >
      <p className="text-sm font-semibold text-gray-900 dark:text-white">{YEATIES_REFUSED_TITLE}</p>
      <p className="text-sm text-gray-600 dark:text-gray-300">
        {YEATIES_REFUSED_MESSAGE}
        {" "}
        {YEATIES_REFUSED_CHANGE_OF_MIND}
      </p>
    </motion.div>
  );
};
